import React from 'react';
import {I18n} from 'react-redux-i18n';
import {get} from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import FormatedDate from './FormatedDate';

export default class DVRInfoTable extends React.PureComponent {
  static defaultProps = {
    tableClassName: 'dvrcard__table'
  }

  render() {
    const {
      tableClassName,
      vehicle,
      serialNo,
      link,
      health: {
        lastMediaDate,
        lastOnlineDate,
        lastIgnitionDate
      }
    } = this.props;

    const pairingMethod = get(link, 'type', 'dsn').toUpperCase();
    const linkValue = get(link, 'value');

    return (
      <Table className={tableClassName}>
        <TableBody>
          <TableRow id="vehicleNumber">
            <TableCell>{I18n.t('page.dvrHealth.dialog.dvr.vehicle')}</TableCell>
            <TableCell>{vehicle}</TableCell>
          </TableRow>
          <TableRow id="serialNumber">
            <TableCell>{I18n.t('page.dvrHealth.dialog.dvr.serial')}</TableCell>
            <TableCell>{serialNo}</TableCell>
          </TableRow>
          {pairingMethod === 'DSN' && (
            <TableRow id="dsn">
              <TableCell>{I18n.t('page.dvrHealth.dialog.dvr.dsn')}</TableCell>
              <TableCell>{linkValue}</TableCell>
            </TableRow>
          )}
          {pairingMethod === 'VIN' && (
            <TableRow id="vin">
              <TableCell>VIN</TableCell>
              <TableCell>{linkValue}</TableCell>
            </TableRow>
          )}
          <TableRow id="lastVideoTriggered">
            <TableCell>
              {I18n.t('page.dvrHealth.dialog.dvr.lastMedia')}
            </TableCell>
            <TableCell>
              <FormatedDate date={lastMediaDate} />
            </TableCell>
          </TableRow>
          <TableRow id="lastDvrPowerOn">
            <TableCell>
              {I18n.t('page.dvrHealth.dialog.dvr.lastOnline')}
            </TableCell>
            <TableCell>
              <FormatedDate
                date={lastOnlineDate}
                format="configuration.fullDateTimeFormat"
              />
            </TableCell>
          </TableRow>
          <TableRow id="lastEngineIgnitionOn">
            <TableCell>
              {I18n.t('page.dvrHealth.dialog.dvr.lastIgnition')}
            </TableCell>
            <TableCell>
              <FormatedDate date={lastIgnitionDate} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }
}
